/**
 * Demo Mode Utility
 * 
 * Handles URL parameter-based demo mode for showcasing different production states.
 * Use ?demo=day0 or ?demo=day10 in the URL to activate demo mode.
 */

export type DemoMode = 'day0' | 'day10' | null;

/**
 * Gets the current demo mode from URL parameters
 * @returns 'day0', 'day10', or null if not in demo mode
 */
export const getDemoMode = (): DemoMode => {
  const params = new URLSearchParams(window.location.search);
  const demo = params.get('demo');
  
  if (demo === 'day0' || demo === 'day10') {
    return demo;
  }
  
  return null;
};

/**
 * Checks if the app is currently in demo mode
 * @returns true if in demo mode, false otherwise
 */
export const isDemoMode = (): boolean => {
  return getDemoMode() !== null;
};

